<template>
  <div class="img-template-box" :style="scaleStyle">
    <el-tooltip v-model="tipVisiable" content="点击更换选择素材" v-if="draggableResize"
                placement="top-end" effect="light">
      <i class="el-icon-sort swop-img" @click="onSwop">切换图片</i>
    </el-tooltip>
    <div class="img-template" :style="calcContainerStyle(data)" :alt="data.name" @drop="onDrop" @dragover="onDragover">
      <draggable-resize :key="selectedIndex"
                        @dragstop="onDragstop"
                        @resizestop="onResizstop"
                        :scale-ratio="scale"
                        class="resize-dom"
                        :resizable="true"
                        :parent="false"
                        :active="true"
                        :z="20"
                        :w="+activeItem.width"
                        :h="+activeItem.height"
                        :x="+activeItem.left"
                        :y="+activeItem.top"
                        v-if="selectedIndex !== null && draggableResize">
            <span class="img-item"
                  :style="calcDragItemStyle">
                 <img :alt="activeItem.name" :src="activeItem.url"/>
            </span>
      </draggable-resize>
      <template v-for="(item, index) in data.json.data">
                <span class="img-item" v-if="index !== selectedIndex && draggableResize"
                      :class="{'selected': index === selectedIndex}"
                      :style="calcStyle(item, index)"
                      :key="index">
                    <img :alt="item.name" :src="item.url" @click="onImgClick(index)"/>
                </span>
        <span class="img-item" v-if="!draggableResize"
              :style="calcStyle(item, index)"
              :key="index">
                    <img :alt="item.name" :src="item.url"/>
                </span>
      </template>
    </div>
  </div>
</template>
<script>
    import draggableResize from '../../components/draggable-resize/draggable-resizable';
    import {pt_group_item} from '../../../const';
    import Util from '@/util.js';

    export default {
        components: {draggableResize},
        props: {
            data: {
                type: Object,
                default() {
                    return {
                        widthHeight: '', json: {
                            width: 0, height: 0, data: []
                        }
                    }
                }
            },
            // selectedIndex: {type: Number, default: null},
            size: {
                type: Object,
                default() {
                    return {width: 0, height: 0}
                }
            },
            rootScale: {type: Number, default: 1},
            draggableResize: Boolean
        },
        data() {
            return {
                selectedIndex: null,
                tipVisiable: true
            }
        },
        computed: {
            scale() {
                let w = +this.size.width;
                let h = +this.size.height;
                if (w === 0 || h === 0) {
                    return 1;
                }
                let pw = this.data.json.width;
                let ph = +this.data.json.height;
                return Util.getScaleWidthAndHeight(w, h, pw, ph) * this.rootScale
            },
            activeItem() {
                if (this.selectedIndex === null) {
                    return {};
                }
                let item = this.data.json.data[this.selectedIndex];
                return item;
            },
            calcDragItemStyle() {
                if (this.selectedIndex === null) {
                    return;
                }
                return `width:100%;height:100%;left:${0}px;top:${0}px;`
            },
            scaleStyle() {
                let data = this.data;
                if (!this.data || !data.json) {
                    return '';
                }
                let scale = this.scale;
                let w = data.json.width * scale;
                let h = data.json.height * scale;
                return `width:${w}px;height:${h}px;backgroundColor:RGBA(0,0,0,0)`;
            }
        },
        methods: {
            onSwop(ev) {
                let cIdx = this.selectedIndex === null ? -1 : this.selectedIndex;
                cIdx += 1;
                let len = this.data.json.data.length;
                if (cIdx > len - 1) {
                    cIdx = 0;
                }
                this.setSelectedIndex(cIdx);
            },
            setSelectedIndex(idx) {
                this.selectedIndex = idx;
                this.$store.commit('group/next_select', idx);
            },
            calcContainerStyle(data) {
                if (!data || !data.json) {
                    return '';
                }
                let scale = this.scale;
                let w = data.json.width;
                let h = data.json.height;
                return `width:${w}px;height:${h}px;transform: scale(${scale})`;
            },
            calcStyle(item, zIndex) {
                if (!this.data || !this.data.json) {
                    return '';
                }
                let w = parseInt(item.width);
                let h = parseInt(item.height);
                let left = parseInt(item.left);
                let top = parseInt(item.top);
                return `width:${w}px;height:${h}px;left:${left}px;top:${top}px;z-index: ${zIndex}`
            },
            onImgClick(index) {
                this.selectedIndex = index;
                this.$store.commit('group/next_select', index);
            },
            updatePosition(left, top, width, height) {
                let item = this.activeItem;
                item.left = left;
                item.top = top;
                if (width) {
                    item.width = width;
                }
                if (height) {
                    item.height = height;
                }
            },
            onDragstop(left, top, width, height) {
                this.updatePosition(left, top);
            },
            onResizstop(left, top, width, height) {
                this.updatePosition(left, top, width, height);
            },
            onDrop(ev) {
                ev.preventDefault();
                let dataStr = ev.dataTransfer.getData("materialData");
                if (dataStr) {
                    let data = JSON.parse(dataStr);
                    let wh = data.widthHeight.split('x');
                    let obj = Object.assign({}, pt_group_item, {
                        left: 0,
                        top: 0,
                        width: +wh[0],
                        height: +wh[1],
                        name: data.name,
                        url: data.url
                    });
                    this.$emit('onAddNewImg', obj);
                    this.data.json.data.push(obj);
                    this.setSelectedIndex(this.data.json.data.length - 1);
                }
            },
            onDragover(ev) {
                ev.preventDefault();
            }
        }
    }
</script>
<style lang="scss">
  @import "./index.scss";
</style>